// src/modules/app-views/leads/pages/Init/modals/LeadsParametersModal/modals/MetaConnectModal/index.jsx
// *******************************************************************************
// META CONNECT MODAL
// *******************************************************************************
// Guides the user through connecting a DataSource to a Meta (Facebook) Page,
// enabling real-time lead capture from Meta Lead Ads via the Graph API webhook.
//
// Flow:
//   Step 1 — OAuth authorization (popup) → fetches list of Pages
//   Step 2 — Page selection → subscribe page to leadgen events
// *******************************************************************************
import { useCallback, useMemo } from 'react';
import { FacebookFilled } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import appService from 'services/appService';
import axiosService from 'services/axiosService';
import { API } from 'constants/Api';
import step1Fn from './Step1';
import step2Fn from './Step2';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const MetaConnectModal = ({ show, setShow, dataSource, onSuccess }) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = useCallback(async ({ form, setLoading }) => {
    const values = form.getFieldsValue(true);
    const pageId = values._pageId;
    const pages = values._pages || [];
    const selectedPage = pages.find(p => p.id === pageId);

    if (!selectedPage) {
      appService.message({ flag: 'w', text: 'select_page_first' });
      return false;
    }

    setLoading(true);
    try {
      await axiosService.post({
        url: API.DATA_SOURCES.META_SUBSCRIBE,
        data: {
          dataSourceId: dataSource._id,
          pageId: selectedPage.id,
          pageName: selectedPage.name,
          pageAccessToken: selectedPage.accessToken,
        },
      });

      appService.message({ flag: 's', text: 'meta_connect_success' });

      // Notify parent with updated fields so the table reflects the change
      onSuccess?.({
        ...dataSource,
        type: 'meta-ads',
        metaPageId: selectedPage.id,
        metaPageName: selectedPage.name,
      });
    } catch (error) {
      console.error('[MetaConnectModal] subscribe error:', error);
      appService.message({ flag: 'e', text: 'error_saving' });
      return false; // keep modal open
    } finally {
      setLoading(false);
    }
  }, [dataSource, onSuccess]);

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  const steps = useMemo(() => [step1Fn(), step2Fn()], []);

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      title="connect_meta_page"
      icon={<FacebookFilled style={{ color: '#1877F2' }} />}
      steps={steps}
      onFinish={handleFinish}
      width={540}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default MetaConnectModal;
